import React from "react";
import { Link } from "react-router-dom";

const WebsiteFooter = () => {
  return (
    <footer className="website-footer">

      <div className="footer-container">

        {/* Brand */}
        <div className="footer-brand">

          <Link
            to="/"
            className="footer-logo"
          >
            <span className="logo-mark">
              H
            </span>

            <span>
              Harsha <strong>IT</strong>
            </span>
          </Link>

          <p>
            Modern technology solutions for businesses,
            schools, restaurants, pharmacies, hotels and
            growing organizations.
          </p>

        </div>


        {/* Company */}
        <div className="footer-column">

          <h4>
            Company
          </h4>

          <Link to="/about">
            About Us
          </Link>

          <Link to="/products">
            Products
          </Link>

          <Link to="/contact">
            Contact
          </Link>

        </div>


        {/* Services */}
        <div className="footer-column">

          <h4>
            Services
          </h4>

          <span>
            School Websites
          </span>

          <span>
            Restaurant Solutions
          </span>

          <span>
            Pharmacy Solutions
          </span>

          <span>
            Hotel Solutions
          </span>

          <span>
            E-Commerce Solutions
          </span>

          <span>
            CRM Solutions
          </span>

        </div>


        {/* Contact */}
        <div className="footer-column">

          <h4>
            Contact
          </h4>

          <a href="tel:8840514251">
            8840514251
          </a>

          <a href="tel:8826882142">
            8826882142
          </a>

          <a href="mailto:harshait.support.com">
            harshait.support.com
          </a>

        </div>

      </div>


      {/* Bottom */}
      <div className="footer-bottom">

        <p>
          © {new Date().getFullYear()} Harsha IT.
          All rights reserved.
        </p>

        <div className="footer-bottom-links">

          <Link to="/about">
            About
          </Link>

          <Link to="/contact">
            Contact
          </Link>

        </div>

      </div>

    </footer>
  );
};

export default WebsiteFooter;